<template>
  <div>
    <air-error-401 />
    d
  </div>
</template>
<script>
import AirError401 from '@/components/system/Errors/401'
export default {
  components: {
    AirError401,
  },
}
</script>
